import React from 'react';

import EmailIconSvg from '../../content/assets/email.svg';

import './Newsletters.css';

export const NewsletterSignupForm = () => {
  return (
    <div id="revue-embed">
      <form
        action="https://www.getrevue.co/profile/chakshunyu/add_subscriber"
        method="post"
        id="revue-form"
        name="revue-form"
        target="_blank"
      >
        <div className="revue-form-column">
          <h1>Uncommon React</h1>
          <p>
            A newsletter helping you become a better React developer by focusing on the less commonly discussed topics,
            like testing, readability, and more.
          </p>
          <p>Subscribe to get the latest editions by email.</p>
          <EmailIconSvg className="email-icon" />
        </div>
        <div className="revue-form-column">
          <div className="revue-form-group">
            <input
              className="revue-form-field"
              placeholder="Your first name"
              type="text"
              name="member[first_name]"
              id="member_first_name"
            />
          </div>
          <div className="revue-form-group">
            <input
              className="revue-form-field"
              placeholder="Your email address"
              type="email"
              name="member[email]"
              id="member_email"
            />
          </div>
          <div className="revue-form-actions">
            <input type="submit" value="Subscribe" name="member[subscribe]" id="member_submit" />
          </div>
          <div className="revue-form-footer">
            By subscribing, you agree with Revue’s{' '}
            <a target="_blank" href="https://www.getrevue.co/terms" rel="noreferrer">
              Terms of Service
            </a>{' '}
            and{' '}
            <a target="_blank" href="https://www.getrevue.co/privacy" rel="noreferrer">
              Privacy Policy
            </a>
            .
          </div>
        </div>
      </form>
    </div>
  );
};
